import { normalizeJob } from '@/composables/useJobPresentation.js'

export async function fetchOverviewSummary(requestJson, {
  recentJobLimit = 10,
  analyticsLimit = 20,
} = {}) {
  const params = new URLSearchParams({
    recentJobLimit: String(recentJobLimit),
    analyticsLimit: String(analyticsLimit),
  })

  const data = await requestJson(`/overview/summary?${params}`)
  return {
    summary: data?.summary || {},
    recentJobs: Array.isArray(data?.recentJobs) ? data.recentJobs.map(normalizeJob) : [],
    stalePlans: Array.isArray(data?.stalePlans) ? data.stalePlans : [],
    analytics: data?.analytics || null,
  }
}
